module.exports = __webpack_public_path__ + "static/img/product_5.1c1f710.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_5.jpg
// module id = DwSK
// module chunks = 1